export default "__VITE_ASSET__BElL4lO9__"